import WaterDropOutlinedIcon from "@mui/icons-material/WaterDropOutlined";
import { type FC } from "react";

import { FilterRange } from "~/components/UI/FilterRange";

import { useLiquidityRangeFilter } from "./useLiquidityRangeFilter";

export const LiquidityRangeFilter: FC = () => {
  const { onChangeLiquidityFilter, initialValue } = useLiquidityRangeFilter();

  return (
    <FilterRange
      label="Liquidity"
      icon={<WaterDropOutlinedIcon fontSize="inherit" />}
      initialValue={initialValue}
      onChange={onChangeLiquidityFilter}
    />
  );
};
